import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('facebook-filled-circle-icon');
export var FacebookFilledCircleIcon = function FacebookFilledCircleIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: cls.name(className),
    width: "16",
    height: "16",
    viewBox: "0 0 49 49"
  }, React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM26 17.6V20H30L29.5 24H26V36H21.2V24H18V20H21.2V17.6C21.2 14.65 22.8 12 26.8 12H30V16H27.9C26.25 16 26 16.55 26 17.6Z"
  }));
};